import './App.css';
import './ProjectCard.css';
function App() {
  return (
    <div className='portfolio'>
      <div className='menu'>
        <div className='mName'>Miranda Tchakalova</div>
        <div className='mBtns'>  
          <a href='#aboutMe'><button>About Me</button></a>
          <a href='#lstProjects'><button>Projects</button></a>
          <a href='#contact'><button>Contact</button></a>
        </div>
      
      </div>
      <div className='banner' id='aboutMe'>
        <div className='portimg'>
          <img id='profil' src='./images/photoMiranda.jpg'></img>
        </div>
        <div className='description'>
          <div id='name'><h1>Welcome !</h1></div>
          <div id='txtDesc'>
          I am a software developer who loves creating fun and practical software. 
          From finnancial software to games, 
          I am all about writing clean, efficient code and solving interesting challenges.
          Check out some of the projects I have been working on. 
          </div>
        </div>
        <div id='introProjects'>I hope you find something that catches your eye!</div>
      </div>

      <div className='projects' id='lstProjects'>
        <div class="flip-card">
          <div class="flip-card-inner">
            <div class="flip-card-front">
              <img className='icons' src='./images/Icons/metaverse-icon.png'></img>
              <p class="title">Physics Builder</p>
              <p>VR building software</p>
            </div>
            <div class="flip-card-back">
              <p class="title">An VR App that lets the users build using realistic physics. User can also stick objects to each other and paint with all the color they want</p>
              <p class='languages'> C# - Unity 3D - HTC API </p>
              <p><a className='projectUrl' href='./Documents/Projects/tchakalovPhysicsBuilderRapport.pdf'>Click here for more info</a></p>
            </div>
          </div>
        </div>

        <div class="flip-card">
          <div class="flip-card-inner">
            <div class="flip-card-front">
              <img className='icons' src='./images/Icons/leaf-environment-care-icon.png'></img>
              <p class="title">CO₂ Calculator</p>
              <p>Travel comsumption of CO₂ calculator</p>
            </div>
            <div class="flip-card-back">
              <p class="title">A software in which the user can choose two cities around the globe, calculate an itinarary and the CO₂ needed to make the travel</p>
              <p class='languages'>C# - SQL - React</p>
              <p><a className='projectUrl' href='./Documents/Projects/Co2_app.pdf'>Click here for more info</a></p>
            </div>
          </div>
        </div>

        <div class="flip-card">
          <div class="flip-card-inner">
            <div class="flip-card-front">
              <img className='icons' src='./images/Icons/gaming-gamepad-icon.png'></img>
              <p class="title">Grep project</p>
              <p>A healthcare game for senior citizens</p>
            </div>
            <div class="flip-card-back">
              <p class="title">A game made for seniors that collects their grip strength and sends it to their doctor in order to insure better monitoring of their health</p>
              <p class='languages'>C# - Unity 3D - SQL - Python </p>
              <p> <a className='projectUrl' href ='https://iss.unige.ch/news/creation-de-jeux-innovants-pour-seniors/'>Click here for more info</a></p>
            </div>
          </div>
        </div>

        <div class="flip-card">
          <div class="flip-card-inner">
            <div class="flip-card-front">
              <img className='icons' src='./images/Icons/copy-file-icon.png'></img>
              <p class="title">Excel - Json converter</p>
              <p>Automatic Data converter</p>
            </div>
            <div class="flip-card-back">
              <p class="title">Software that automatically converts any Excel data into Json, made for a private bank enabling them easy communication between two softwares</p>
              <p class='languages'>VBA - C# - Newtonsoft API</p>
            </div>
          </div>
        </div>

        <div class="flip-card">
          <div class="flip-card-inner">
            <div class="flip-card-front">
              <img className='icons' src='./images/Icons/tech-icon.png'></img>
              <p class="title">RoboTrackeur</p>
              <p>Autonomous tracking robot</p>
            </div>
            <div class="flip-card-back">
              <p class="title">Building and programming of a robot that can locate itself in space and go to specific points while avoiding obstacles</p>
              <p class='languages'>C# - lots of Mathetamics </p>
              <p> <a className='projectUrl' href='./Documents/Projects/RoboTrackeur.pdf'>Click here for more info</a></p>
            </div>
          </div>
        </div>

        <div class="flip-card">
          <div class="flip-card-inner">
            <div class="flip-card-front">
              <img className='icons' src='./images/Icons/rpa-robotic-process-automation-icon.png'></img>
              <p class="title">Spy Bot</p>
              <p>Remote controlled robot</p>
            </div>
            <div class="flip-card-back">
              <p class="title">Building and programming of a remote controlled robot. This robot can be controlled by a phone app, the user can see it's video feed on his/ her phone</p>
              <p class='languages'>Shell - Javascript</p>
              <p><a className='projectUrl' href='./Documents/Projects/SpyBot_Doc.pdf'>Click here for more info</a></p>
            </div>
          </div>
        </div>

        <div class="flip-card">
          <div class="flip-card-inner">
            <div class="flip-card-front">
              <img className='icons' src='./images/Icons/woman-makeup-icon.png'></img>
              <p class="title">B-well</p>
              <p>A wellness appointement manager</p>
            </div>
            <div class="flip-card-back">
              <p class="title">An app that will allow users to make and manage appointements with different services such as massage places, hairdressers or physiotherapists </p>
              <p class='languages'>JS - React - C# - SQL </p>
              <p><a className='projectUrl'>Project is currently being made</a></p>
            </div>
          </div>
        </div>
      </div>
      
      <div className='footer' id='contact'>
        <div id='cName'>
          <div id='fName'>Miranda Tchakalova's portfolio</div>
          <div id='copyright'>© 2024 Miranda Tchakalova</div>
        </div>
        <div id='links'>
          {/* <div class='contactMe'>Feel Free to contact me :</div> */}
          <div id='conInfo'>  
            <a href='./Documents/CV_Miranda_Pr_En.pdf'><img className='contactLink' src='./images/Icons/CV.png'></img></a>
            <a href='mailto: miranda.tchakalova@gmail.com'><img className='contactLink' src='./images/Icons/gmail-icon.png'></img></a>
            <a href='http://www.linkedin.com/in/miranda-tchakalova'><img className='contactLink' src='./images/Icons/linkedin-app-icon.png'></img></a>
          </div>
        </div>
        <div id='disclaimer'>
          <div id='titleDisc'>Disclaimer :</div>
          <div id='txtDisclaimer'>
              No templates were used or harmed during the making of this site 😁
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
